import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminPricing from "./pages/AdminPricing";
import AdminSettings from "./pages/AdminSettings";
import AdminDrivers from "./pages/AdminDrivers";
import AdminCommissions from "./pages/AdminCommissions";
import AdminCustomers from "./pages/AdminCustomers";
import AdminPromotions from "./pages/AdminPromotions";
import AdminCreateQuote from "./pages/AdminCreateQuote";
import CustomerSignup from "./pages/CustomerSignup";
import CustomerLogin from "./pages/CustomerLogin";
import CustomerVerifyLink from "./pages/CustomerVerifyLink";
import CustomerDashboard from "./pages/CustomerDashboard";
import BookingResponse from "./pages/BookingResponse";
import QuoteResponse from "./pages/QuoteResponse";
import LoyaltyProgram from "./pages/LoyaltyProgram";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import AirportTransferBrussels from "./pages/AirportTransferBrussels";
import PrivateChauffeurBrussels from "./pages/PrivateChauffeurBrussels";
import TaxiBruxelles from "./pages/TaxiBruxelles";
import TaxiAeroportBruxelles from "./pages/TaxiAeroportBruxelles";
import TransfertZaventemBruxelles from "./pages/TransfertZaventemBruxelles";
import NavetteAeroportBruxelles from "./pages/NavetteAeroportBruxelles";
import TaxiCharleroiBruxelles from "./pages/TaxiCharleroiBruxelles";
import PaiementEnLigneSecurise from "./pages/PaiementEnLigneSecurise";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";

// New SEO Pages - Cities
import TaxiAnvers from "./pages/TaxiAnvers";
import TaxiGand from "./pages/TaxiGand";
import TaxiLiege from "./pages/TaxiLiege";
import TaxiNamur from "./pages/TaxiNamur";
import TaxiLouvain from "./pages/TaxiLouvain";
import TaxiBruges from "./pages/TaxiBruges";

// New SEO Pages - Services
import ChauffeurMariageBruxelles from "./pages/ChauffeurMariageBruxelles";
import TransfertEvenementEntreprise from "./pages/TransfertEvenementEntreprise";
import NavetteGareMidi from "./pages/NavetteGareMidi";
import TransfertVIPBruxelles from "./pages/TransfertVIPBruxelles";
import LocationVoitureChauffeurJournee from "./pages/LocationVoitureChauffeurJournee";

// New SEO Pages - Routes
import ZaventemCentreBruxelles from "./pages/ZaventemCentreBruxelles";
import CharleroiAnvers from "./pages/CharleroiAnvers";
import TransfertBruxellesAmsterdam from "./pages/TransfertBruxellesAmsterdam";
import TransfertBruxellesParis from "./pages/TransfertBruxellesParis";
import ZaventemGareMidi from "./pages/ZaventemGareMidi";

import { Toaster } from "./components/ui/sonner";
import { LanguageProvider } from "./LanguageContext";
import CookieBanner from "./components/CookieBanner";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/pricing" element={<AdminPricing />} />
            <Route path="/admin/settings" element={<AdminSettings />} />
            <Route path="/admin/drivers" element={<AdminDrivers />} />
            <Route path="/admin/commissions" element={<AdminCommissions />} />
            <Route path="/admin/customers" element={<AdminCustomers />} />
            <Route path="/admin/promotions" element={<AdminPromotions />} />
            <Route path="/admin/create-quote" element={<AdminCreateQuote />} />
            
            {/* Customer Routes */}
            <Route path="/signup" element={<CustomerSignup />} />
            <Route path="/client/signup" element={<CustomerSignup />} />
            <Route path="/client/login" element={<CustomerLogin />} />
            <Route path="/verify-magic-link" element={<CustomerVerifyLink />} />
            <Route path="/client/verify-link" element={<CustomerVerifyLink />} />
            <Route path="/client/dashboard" element={<CustomerDashboard />} />
            <Route path="/booking-response/:bookingId" element={<BookingResponse />} />
            <Route path="/quote-response/:quoteId" element={<QuoteResponse />} />
            <Route path="/loyalty" element={<LoyaltyProgram />} />
            <Route path="/fidelite" element={<LoyaltyProgram />} />
            
            {/* Legal Pages */}
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/politique-confidentialite" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/cgu" element={<TermsOfService />} />
            <Route path="/conditions" element={<TermsOfService />} />
            
            {/* SEO Pages */}
            <Route path="/airport-transfer-brussels" element={<AirportTransferBrussels />} />
            <Route path="/private-chauffeur-brussels" element={<PrivateChauffeurBrussels />} />
            <Route path="/brussels-airport-transfer" element={<AirportTransferBrussels />} />
            <Route path="/luxury-chauffeur-belgium" element={<PrivateChauffeurBrussels />} />
            
            {/* New SEO Pages - Priority Keywords */}
            <Route path="/taxi-bruxelles" element={<TaxiBruxelles />} />
            <Route path="/taxi-aeroport-bruxelles" element={<TaxiAeroportBruxelles />} />
            <Route path="/transfert-zaventem-bruxelles" element={<TransfertZaventemBruxelles />} />
            <Route path="/navette-aeroport-bruxelles" element={<NavetteAeroportBruxelles />} />
            <Route path="/taxi-charleroi-bruxelles" element={<TaxiCharleroiBruxelles />} />
            <Route path="/paiement-en-ligne-securise" element={<PaiementEnLigneSecurise />} />
            
            {/* SEO Pages - Cities */}
            <Route path="/taxi-anvers" element={<TaxiAnvers />} />
            <Route path="/taxi-gand" element={<TaxiGand />} />
            <Route path="/taxi-liege" element={<TaxiLiege />} />
            <Route path="/taxi-namur" element={<TaxiNamur />} />
            <Route path="/taxi-louvain" element={<TaxiLouvain />} />
            <Route path="/taxi-bruges" element={<TaxiBruges />} />
            
            {/* SEO Pages - Services */}
            <Route path="/chauffeur-mariage-bruxelles" element={<ChauffeurMariageBruxelles />} />
            <Route path="/transfert-evenement-entreprise" element={<TransfertEvenementEntreprise />} />
            <Route path="/navette-gare-midi" element={<NavetteGareMidi />} />
            <Route path="/transfert-vip-bruxelles" element={<TransfertVIPBruxelles />} />
            <Route path="/location-voiture-chauffeur-journee" element={<LocationVoitureChauffeurJournee />} />
            
            {/* SEO Pages - Routes */}
            <Route path="/zaventem-centre-bruxelles" element={<ZaventemCentreBruxelles />} />
            <Route path="/charleroi-anvers" element={<CharleroiAnvers />} />
            <Route path="/transfert-bruxelles-amsterdam" element={<TransfertBruxellesAmsterdam />} />
            <Route path="/transfert-bruxelles-paris" element={<TransfertBruxellesParis />} />
            <Route path="/zaventem-gare-midi" element={<ZaventemGareMidi />} />
            
            {/* Payment Pages */}
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/payment-cancel" element={<PaymentCancel />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
        <CookieBanner />
      </div>
    </LanguageProvider>
  );
}

export default App;
